/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCoffee = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M17 7h.024a5 5 0 0 1 .977 9.9L18 17a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7zm-1 2H4v8a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3zm2 .171v5.658a3.001 3.001 0 0 0 0-5.658zM6 2v3H4V2zm4 0v3H8V2zm4 0v3h-2V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCoffee as Coffee };
